import { inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';
import { ClusterApiService } from '@shared/services';
import { CLUSTER_TREE_SELECT_CONFIG } from '@shared/components/generic-treeselect/generic-treeselect.configs';

export const clusterFormConfig = (): FormConfig => {
  const clusterApiService = inject(ClusterApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã cụm', required: true, width: 'half',
        type: 'text', validators: [Validators.pattern(/^[a-z0-9-]+$/)],
        placeholder: 'Chữ thường, số, dấu gạch ngang',
        tooltip: (editMode: boolean, formValue: any) =>
          editMode && formValue.code ? 'Không thể sửa mã cụm đã có' : '',
        customErrorMessage: 'Mã cụm là bắt buộc và chỉ chứa chữ thường, số, dấu gạch ngang',
        disabled: (editMode: boolean, formValue: any) => editMode && formValue.code
      },
      {
        key: 'name', label: 'Tên cụm', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên cụm'
      },
      {
        key: 'parentId', label: 'Cụm cha', width: 'full',
        type: 'treeselect', config: { ...CLUSTER_TREE_SELECT_CONFIG, service: clusterApiService }
      },
      {
        key: 'fromDate', label: 'Ngày bắt đầu', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn ngày bắt đầu'
      },
      {
        key: 'toDate', label: 'Ngày kết thúc', width: 'half',
        type: 'datepicker', placeholder: 'Chọn ngày kết thúc'
      },
      {
        key: 'activeForTaTask', label: 'TA Task?', width: 'half',
        type: 'toggleSwitch', placeholder: 'Cho phép TA Task tại cụm?'
      },
    ]
  };
};
